// extracted by extract-css-chunks-webpack-plugin
module.exports = {"wrapper":"assessor-empty-dashboard__wrapper--jxnHw","images":"assessor-empty-dashboard__images--3U8o2","pop":"assessor-empty-dashboard__pop--3oVA0"};